<template>
  <div class="app__canvas canvas" id="stage" />
</template>

<script>
export default {
  name: 'AppCanvas',
};
</script>

<style lang="scss" scoped>
.canvas {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  background: $color-gradient;
}
</style>

<style>
.canvas#stage canvas {
  mix-blend-mode: overlay;
}
</style>
